import React from "react";
import {
  Card,
  Box,
  Stack,
  Button,
  Grid,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { styled } from "@mui/system";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/autoplay";
import { members } from "../../../../../data/Data";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import MaleProfilePhoto from "../../../../../assets/images/male-doc.png";
import FemaleProfilePhoto from "../../../../../assets/images/female-doc.webp";
import TitleSectionComponent from "../../../../../components/core-components/titleSection";
import { Link } from "react-router-dom";
import { MemberService } from "../../../../../network/MemberService";
import { useQuery } from "@tanstack/react-query";

const MemberCard = styled(Card)(({ theme }) => ({
  padding: theme.spacing(2),
  textAlign: "center",
  borderRadius: "16px",
  boxShadow: "0px 4px 4px 4px rgba(0, 0, 0, 0.2)",
  backgroundColor: "rgba(255, 255, 255, 0.5)",
  marginBottom: theme.spacing(2),
  minHeight: "100%",
  height: "450px",
}));

function MembersSection() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const memberService = new MemberService();

  const { data: membersList } = useQuery({
    queryKey: ["membersList"],
    queryFn: async () => {
      const res = await memberService.getAll({
        limit: 20,
        isFounder: true 
      });
      console.log(res);
      return res?.data;
    },
  });

  return (
    <Grid
      container={!isMobile}
      spacing={4}
      xs={12}
      m={"auto"}
      height={"100%"}
      justifyContent="center"
    >
      <Grid item xs={12}>
        <TitleSectionComponent titleText="Kurucu Üyelerimiz" />
      </Grid>

      <Swiper
        modules={[Autoplay, Navigation]}
        spaceBetween={20}
        slidesPerView={isMobile ? 1 : 4}
        navigation
        scrollbar={{ draggable: true }}
        autoplay={{
          delay: 2000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        }}
        loop={true}
        freeMode={true}
        style={{ padding: "20px 10px" }}
      >
        {membersList?.map((member: any, index: number) => (
          <SwiperSlide key={index}>
            <MemberCard>
              <img
                /* src={member.img} */
                src={
                  member.image ||
                  (member.gender?.toLowerCase() === "male"
                    ? MaleProfilePhoto
                    : FemaleProfilePhoto)
                }
                alt={member.name}
                style={{
                  width: "100%",
                  height: "295px",
                  borderRadius: "16px",
                }}
              />
              <Stack spacing={1} mt={1}>
                <span className="B-18" style={{ fontWeight: 700 }}>
                  {member.title} {member.name} {member.surname}
                </span>
                <span className="B-18">{member.role}</span>
              </Stack>
            </MemberCard>
          </SwiperSlide>
        ))}
      </Swiper>
    </Grid>
  );
}

export default MembersSection;
